import React, { Component } from "react";
import {
  FormControl,
  PanelContainer,
  Panel,
  PanelBody,
} from "@sketchpixy/rubix";

export function MultiCheckBoxField(props) {
  const {
    name,
    questions,
    position,
    onTyping,
    onChangeValue,
    cols,
    answer,
    textanswer,
    multi,
    placeholder,
    textarea,
    small,
  } = props;
  let offset = "col-sm-";
  offset += 12 / cols;

  return (
    <div key={props.position} className="show-with-ease">
      <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
        <Panel>
          <PanelBody className="radio-right-innerbox">
            {questions.map((question, i) => (
              <div
                key={i}
                className={textarea && (i + 1) % 2 === 0 ? "row" : ""}
              >
                <div
                  key={"divMainCheckboxField" + position + i}
                  className={offset}
                >
                  <div
                    key={"divCheckboxField" + position + i}
                    className="col-sm-12"
                    style={{ padding: "0" }}
                  >
                    <PanelContainer
                      containerClasses={
                        multi
                          ? question.main === question.answer
                            ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                            : "rubix-panel-container-with-bottom-shadow-inner"
                          : question.main === answer
                          ? "rubix-panel-container-with-bottom-shadow-inner-selected"
                          : "rubix-panel-container-with-bottom-shadow-inner"
                      }
                    >
                      {question.showSubItems &&
                        question.subItems &&
                        !question.textarea &&
                        question.hasOwnProperty("text1") && (
                          <textarea
                            name={"text1" + name + position + i}
                            id={"text1" + name + position + i}
                            placeholder={
                              question.placeholder1
                                ? question.placeholder1
                                : "Please Specify Other"
                            }
                            rows="1"
                            value={question.text1}
                            style={{
                              border: question.text1
                                ? "1px solid #079EDA"
                                : "1px solid red",
                              borderRadius: 20,
                              width: "90%",
                              marginTop: 10,
                              padding: "5px 10px 5px 10px",
                            }}
                            onChange={(e) =>
                              onTyping({
                                questionIndex: position,
                                index: i,
                                value: e.target.value,
                                field: "text1",
                              })
                            }
                            className="required textarea-modal"
                          ></textarea>
                        )}
                      <label>
                        <Panel
                          key={"radioFieldTilesPanel" + name + position + i}
                          style={{ clear: "both" }}
                        >
                          <PanelBody
                            className="radio-right-innerbox"
                            style={{
                              height:
                                textarea || small
                                  ? "auto"
                                  : multi
                                  ? "222px"
                                  : "193px",
                              lineHeight: 0,
                              padding: 10,
                            }}
                          >
                            <div
                              className="text-center radio-right-innerbox-label"
                              style={{ cursor: "pointer", height: 40 }}
                            >
                              <span className="text-left fg-black radio-right-innerbox-label-text">
                                {question.heading ? (
                                  <div className="tiles-opt-heading">
                                    {question.heading}
                                  </div>
                                ) : (
                                  ""
                                )}
                                {question.main}
                                {question.redMain ? (
                                  <span style={{ color: "red" }}>
                                    {question.redMain}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>

                            {question.showSubItems &&
                              question.subItems &&
                              !question.textarea && (
                                <Panel
                                  style={{ marginTop: 10 }}
                                  key={
                                    "radioFieldTilesPanelInner" +
                                    name +
                                    position +
                                    i
                                  }
                                >
                                  <PanelContainer containerClasses="rubix-panel-container-with-bottom-shadow-overflow">
                                    {question.subLabel ? (
                                      <p
                                        style={{ marginTop: 20, lineHeight: 1 }}
                                      >
                                        {question.subLabel}
                                      </p>
                                    ) : (
                                      ""
                                    )}

                                    <PanelBody className="radio-right-innerbox">
                                      {question.subItems.map((subItem, j) => (
                                        <label
                                          key={j}
                                          style={{
                                            marginTop: "10px",
                                            cursor: "pointer",
                                          }}
                                          className="text-center radio-right-innerbox-label"
                                        >
                                          <span className="text-left fg-black radio-right-innerbox-label-text">
                                            {subItem.heading ? (
                                              <div className="tiles-opt-heading">
                                                {subItem.heading}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            {subItem.main}
                                            {subItem.redMain ? (
                                              <span style={{ color: "red" }}>
                                                {subItem.redMain}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                          </span>

                                          <FormControl
                                            type="radio"
                                            className={"sun-radio-custom"}
                                            key={
                                              "radioFieldTiles" +
                                              name +
                                              position +
                                              i +
                                              j
                                            }
                                            name={
                                              question.multi
                                                ? "checkBox" +
                                                  name +
                                                  position +
                                                  i +
                                                  j
                                                : "checkBox" +
                                                  name +
                                                  position +
                                                  i
                                            }
                                            checked={
                                              question.multi
                                                ? subItem.main ===
                                                  subItem.answer
                                                : subItem.main ===
                                                  question.subAnswer
                                            }
                                            value={subItem.main}
                                            onClick={(e) =>
                                              onChangeValue({
                                                questionIndex: position,
                                                index: i,
                                                indexSecond: j,
                                                value: e.target.value,
                                                ck: "inner",
                                              })
                                            }
                                            label={subItem.main}
                                          />
                                          <img
                                            className={"sun-img-custom"}
                                          ></img>
                                        </label>
                                      ))}
                                    </PanelBody>
                                  </PanelContainer>
                                </Panel>
                              )}
                          </PanelBody>
                        </Panel>
                      </label>
                    </PanelContainer>
                  </div>
                </div>
              </div>
            ))}
          </PanelBody>
        </Panel>
      </PanelContainer>
    </div>
  );
}

export default MultiCheckBoxField;
